import Swiper from 'swiper'

/**
 * Banner element that responds on the scrolling of the document.
 * @extends	HTMLElement
 */
customElements.define(
    'occasions-slider',
    class OccasionsSliderElement extends HTMLElement {
        constructor() {
            super()

            this._slider = null
        }

        /**
         * Gets the .swiper element from the children.
         *
         * @property
         * @returns {(HTMLElement|null)}
         */
        get sliderContainer() {
            return this.querySelector('.swiper')
        }

        /**
         * Gets the .swiper-pagination element from the children.
         *
         * @property
         * @returns {(HTMLElement|null)}
         */
        get paginationContainer() {
            const container = this.sliderContainer
            if (container === null) {
                return null
            }

            return container.querySelector('.swiper-pagination')
        }

        /**
         * Gets the .swiper-controls element from the children.
         *
         * @property
         * @returns {(HTMLElement|null)}
         */
        get nextBtn () {
            const container = this.sliderContainer
            if (container === null) {
                return null
            }

            return container.querySelector('.swiper-control--next');
        }
        /**
         * Gets the .swiper-controls element from the children.
         *
         * @property
         * @returns {(HTMLElement|null)}
         */
        get prevBtn () {
            const container = this.sliderContainer
            if (container === null) {
                return null
            }

            return container.querySelector('.swiper-control--prev');
        }

        /**
         * Gets and sets the settings attribute value.
         *
         * @property
         */
        get settings() {
            try {
                const value = this.getAttribute('settings')
                if (value === null) {
                    return {}
                }

                return JSON.parse(value)
            } catch (error) {
                return {}
            }
        }

        set settings(value) {
            if (typeof value === 'object') {
                this.setAttribute('settings', JSON.stringify(value))
            }
        }

        /**
         * Start the slider.
         */
        connectedCallback() {

            const defaultSettings = {
                spaceBetween: 15,
                slidesPerView: 1,
                navigation: {
                    prevEl: this.prevBtn,
                    nextEl: this.nextBtn,
                },
                pagination: {
                    el: this.paginationContainer,
                },
                breakpoints: {
                    800: {
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    960: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                    1440: {
                        spaceBetween: 60,
                        slidesPerView: 3,
                    },
                },
            }

            //Overwrite any default settings from the settings attribute.
            const settings = Object.assign(defaultSettings, this.settings)
            this._slider = new Swiper(this.sliderContainer, settings)
        }

        /**
         * Clean up event listeners
         */
        disconnectedCallback() {
            this._slider.destroy()
        }
    }
)



// WEBPACK FOOTER //
// ./scripts/web-components/occasions-slider/index.js